import GlobalComponents from './GlobalComponents';

export default GlobalComponents;
